import { useEffect } from "react";

/**
 * A helper hook for handling react-query results.
 *
 * @param {object} params
 * @param {any} params.data - Data returned from query
 * @param {boolean} params.isError - Error state from query
 * @param {object} params.error - Error object from query
 * @param {(data: any) => void} [params.onSuccess] - Callback when data is loaded
 * @param {(err: any) => void} [params.onError] - Callback when error occurs
 */
export const useQueryEffect = ({ data, isError, error, onSuccess, onError }) => {
    // Handle success
    useEffect(() => {
        if (data && onSuccess) {
            onSuccess(data);
        }
    }, [data, onSuccess]);

    // Handle error
    useEffect(() => {
        if (isError && error && onError) {
            onError(error);
        }
    }, [isError, error, onError]);
};

export default useQueryEffect;
